// src/pages/Services.jsx
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const services = [
  {
    title: 'CV Writing',
    description:
      'Professional CV writing tailored to Kenyan job market standards. Highlight your achievements, skills, and career goals to stand out from the competition.',
  },
  {
    title: 'Interview Coaching',
    description:
      'One-on-one coaching to improve your interview confidence, body language, and answers to common questions. Delivered online or in-person.',
  },
  {
    title: 'Career Mentorship',
    description:
      'Get matched with experienced professionals in your field for guidance on job hunting, career growth, and navigating workplace challenges.',
  },
  {
    title: 'Job Advertising',
    description:
      'Are you an employer or recruiter? Reach thousands of active job seekers across Kenya by advertising your job openings on our platform. Listings are subject to quality checks and must comply with our no-fee-to-apply policy.',
  }
];

const Services = () => (
  <>
    
    <main style={styles.main}>
      <h1>Our Services</h1>
      <p>
        At <strong>CurrentJobs.co.ke</strong>, we support job seekers and employers alike with a range of helpful, free services:
      </p>
      <div style={styles.cardGrid}>
        {services.map((service, index) => (
          <div key={index} style={styles.card}>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </main>
 
  </>
);

const styles = {
  main: {
    padding: '2rem',
    maxWidth: '960px',
    margin: 'auto',
    lineHeight: 1.6,
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '1.5rem',
    marginTop: '2rem',
  },
  card: {
    backgroundColor: '#f4f4f4',
    padding: '1.5rem',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
};

export default Services;
